import {
  RECEIVE_CALCULATED_TASK_REPEAT,
  RECEIVE_TASK_INFO,
  CLEAR_REPEATS,
} from '../constants/ActionTypes';

const defaultState = {taskGUID: null, task: {}, server: []};

const repeatTester = (state = defaultState, action) => {
  switch (action.type) {
    case RECEIVE_CALCULATED_TASK_REPEAT:
      return {
        ...state,
        taskGUID: action.taskGUID,
        server: action.data,
      };
    case RECEIVE_TASK_INFO:
      return {
        ...state,
        taskGUID: action.taskGUID,
        task: action.data,
      };
    case CLEAR_REPEATS:
      return defaultState;
    default:
      return state;
  }
}

export default repeatTester;



// WEBPACK FOOTER //
// ./src/reducers/repeatTester.js